import { useState, useEffect } from "react";
import { gql } from "apollo-boost";
import { useLazyQuery } from "@apollo/react-hooks";

import { Ticket } from "../interfaces/ticket";

export const GET_TICKET = gql`
  query getTicket($id: String!) {
    getTicket(id: $id) {
      price
      status
      date
      hour
      minutes
      created_at
      code
      observation
      car {
        number
        organization {
          name
          image
        }
      }
      arrivalLocation {
        name
      }
      departureLocation {
        name
      }
    }
  }
`;

interface useTicketVariables {
  id: any;
}

export const useTicket = (
  variables: useTicketVariables,
  queryOptions: any = {}
) => {
  const [ticket, setTicket] = useState<Ticket>({
    id: 0,
    date: "",
    hour: 0,
    minutes: 0,
    status: 1,
    arrivalLocation: { name: "" },
    departureLocation: { name: "" },
    code: "",
    observation: "",
    car: {
      board: "",
      number: "",
      organization: {
        name: "",
      },
    },
    price: "",
    created_at: "",
  });

  const [getTicket, { loading, data, error, stopPolling }] = useLazyQuery(
    GET_TICKET,
    {
      variables,
      ...queryOptions,
    }
  );

  useEffect(() => {
    getTicket();
  }, []);

  useEffect(() => {
    if (data && data.getTicket) {
      setTicket((prevTicket) => ({
        ...prevTicket,
        ...data.getTicket,
      }));
    }
  }, [data]);

  return {
    ticket,
    data,
    loading,
    error,
    stopPolling,
  };
};
